import * as React from "react";

import { ButtonType5 } from "@visualizeroi/vroi-custom-components";

type Props2 = { setUser_modal: Function; setEmail: Function };

const ThankyouView = ({ setUser_modal, setEmail }: Props2) => {
  return (
    <>
      <div className="Thankyou_header">Success!</div>

      <div className="Thankyou_desc">Check your inbox for your customized report.</div>

      <div className="close_btn_div">
        <button
          className="get_report_btn2  close_btn"
          onClick={() => setUser_modal(false)}
        >
          Close
        </button>
      </div>
    </>
  );
};

export default ThankyouView;
